import { Component, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';

import { LeftSidebarService } from '../../../../../Common/Layout/services/left-sidebar.service';

import { AbstractDialogComponent } from '../../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { UserModel } from '../../../../../Core/Users/models/user.model';

import type { AccountManagementService } from '../../../services/account-management.service';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { UserProfileComponent } from '../user-profile.component';

@Component({
    selector: 'agpr-user-profile-dialog',
    templateUrl: './user-profile-dialog.component.html',
    styleUrls: ['./user-profile-dialog.component.scss'],
    standalone: false
})
export class UserProfileDialogComponent extends AbstractDialogComponent {

    @Input() user: UserModel;
    @Input() addToCurrentAccount: boolean;

    @Output() active: EventEmitter<boolean> = new EventEmitter();

    @ViewChild('userProfile') userProfile: UserProfileComponent;

    readonly buttonTypesEnum = ButtonTypesEnum;

    loading: boolean = false;

    constructor(
        public coreDialogService: CoreDialogService,
        @Inject(LeftSidebarService) public accountManagementService: AccountManagementService
    ) {
        super(coreDialogService, 'UserProfile');
    }

    saveUser() {
        this.loading = true;
        if (!this.user.id) {
            this.accountManagementService.createUser(this.user, this.addToCurrentAccount).then(done => {
                this.loading = false;
                this.closeDialog();
            }).catch(error => {
                this.loading = false;
            });
        } else {
            this.accountManagementService.saveUser(this.user).then(done => {
                this.loading = false;
                this.closeDialog();
            }).catch(error => {
                this.loading = false;
            });
        }
    }

    toggleActive(active: boolean) {
        this.active.emit(active);
    }
}
